import React,{Component} from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";

import { ToastContainer ,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import  Login from './components/Login/Login';
import firebase from './components/firebase'; 



export default class App extends Component {

  constructor(props) {
    super(props);
  
    this.state = {logged_in:false};
  }


  componentDidMount(){
    var that = this;
    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            // User is signed in.
            console.log(user);
            that.setState({logged_in:true});
             
        } else {
            // No user is signed in.
            console.log("No user");
            that.setState({logged_in:false});
            
        }
    })
  }
    

  render(){

   
  return(
  <div>
  <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.TOP_RIGHT} />
  {<Router basename={process.env.REACT_APP_BASENAME || ""}>
   <div>
      {routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={withTracker(props => {
              return (
                <route.layout {...props}>
                  <route.component {...props} />
                </route.layout>
              );
            })}
          />
        );
      })}
    </div>
  </Router>
}
  </div>
);
}

}
